export default __webpack_public_path__ + "static/side-f2f5959fc3f2cb37b4a3114eb6a01145.png";